import React from "react";
import shield_purple from "../../assets/shield-purple.svg";

export const AnswerIcon: React.FC = () => {
    return <img src={shield_purple} alt="Answer Icon" className="icon-md" role="img" />;
};
